import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';

import { pure } from '@dbk/ui-react-utils';

import { Large } from '@dbk/ui-text';
import { NO_DATA_TEXT } from '../../../constants';

import styles from './no-data-chart.styles';

function NoDataChart({ marginTop, messages }) {
  const style = {
    ...styles.root,
    marginTop,
  };

  return (
    <View
      style={style}
      testID="no-data">
      <Large>{messages[NO_DATA_TEXT]}</Large>
    </View>
  );
}

NoDataChart.propTypes = {
  marginTop: PropTypes.number,
};

NoDataChart.defaultProps = {
  marginTop: 0,
};


export default pure(NoDataChart);
